<!-- <div class="background-image-container mt-ncs">
  <div class="container">
    <div class="jumbotron jumbotron-fluid">
      <ds-text-section *ngIf="hasHomeNewsMetadata; else dsDefaultHomeNews" [sectionId]="'site'" [textRowSection]="homeNewsSection"
                              [site]="(site$ | async)"></ds-text-section>
    </div>
  </div>
  <picture class="background-image">
    <source type="image/webp" srcset="assets/dspace/images/banner.webp 2000w, assets/dspace/images/banner-half.webp 1200w, assets/dspace/images/banner-tall.webp 768w">
    <source type="image/jpg" srcset="assets/dspace/images/banner.jpg 2000w, assets/dspace/images/banner-half.jpg 1200w, assets/dspace/images/banner-tall.jpg 768w">
    <img alt="" [src]="'assets/dspace/images/anid_bg_new.svg'"/>
  </picture>
</div>

<ng-template #dsDefaultHomeNews>
  <div class="d-flex flex-wrap">
    <div>
      <h1 class="display-3">Bienvenidos al Repositorio ANID</h1>
      <p>Lorem ipsum dolor sit amet consectetur. Vitae amet quis diam vestibulum etiam urna viverra vulputate. Mattis adipiscing erat vitae et cras aliquam. </p>
    </div>
  </div>


</ng-template> -->
 <div class="header">
  <div class="header__cols">
    <div class="header__col">
      <h1>Bienvenidos al <br> CRIS <b>ANID</b></h1>
      <p>Lorem ipsum dolor sit amet consectetur. Vitae amet quis diam vestibulum etiam urna viverra vulputate. Mattis adipiscing erat vitae et cras aliquam.</p>
      <div class="chips">
        <span class="chip chip--lg chip--primary">10.433 publicaciones</span>
        <span class="chip chip--lg chip--dark">4.655 autores</span>
        <span class="chip chip--lg chip--info--light">433 instituciones</span>
      </div>
    </div>
  </div>
  <div class="header__search">
    <ds-search-form [inPlaceSearch]="false" [searchPlaceholder]="'Buscar...' | translate"></ds-search-form>
  </div>
  <div class="header__inv">
    <h3>Investigadores de diversas fuentes</h3>
    <div class="slider">
      <div class="slide">
        <img src="/../../assets/images/investigador.png" alt="logo portal del investigador">
      </div>
      <div class="slide">
        <img src="/../../assets/images/anid.png" alt="logo repositorio anid">
      </div>
      <div class="slide">
        <img src="/../../assets/images/espacio_ciencia.png" alt="logo espacio ciencia">
      </div>
      <div class="slide">
        <img src="/../../assets/images/scopus.png" alt="logo scopus">
      </div>
    </div>
  </div>
 </div>
 <div class="layout">
    <div class="section--1">
      <div class="indicadores">
        <div class="indicador">
          <span class="material-symbols-outlined icon--1">account_balance</span>
          <h6>12345</h6>
          <p>Publicaciones Académicas</p>
        </div>
        <div class="indicador">
          <span class="material-symbols-outlined icon--2">news</span>
          <h6>12345</h6>
          <p>Publicaciones Investigación</p>
        </div>
        <div class="indicador">
          <span class="material-symbols-outlined icon--3">school</span>
          <h6>12345</h6>
          <p>Tesis</p>
        </div>
        <div class="indicador">
          <span class="material-symbols-outlined icon--4">person_pin</span>
          <h6>12345</h6>
          <p>Personal Investigador</p>
        </div>
        <div class="indicador">
          <span class="material-symbols-outlined icon--5">file_present</span>
          <h6>12345</h6>
          <p>Proyectos Convenios</p>
        </div>
        <div class="indicador">
          <span class="material-symbols-outlined icon--6">apartment</span>
          <h6>12345</h6>
          <p>Organización</p>
        </div>
      </div>
      <div class="highchart">
        <img src="/../../assets/images/highcharts.png" alt="">
      </div>
    </div>
    <div class="section--2">
      <div class="faq">
        <div class="title">
          <span class="icon material-symbols-outlined">help</span>
        </div>
        <h3>Preguntas Frecuentes
          </h3>
        
        <div class="accordion" id="accordionExample">
          <div class="card">
            <div class="card-header" id="headingOne">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  Lorem ipsum
                </button>
              </h2>
            </div>

            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
              <div class="card-body">
                Lorem ipsum dolor sit amet consectetur. Etiam mauris mollis pretium lectus elementum magnis sed non. Dignissim tincidunt aliquet facilisis enim. In egestas eleifend morbi vel feugiat in nam sed. Dui vitae viverra ullamcorper neque mattis massa laoreet tincidunt faucibus.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Lorem ipsum
                </button>
              </h2>
            </div>
            <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <div class="card-body">
                Lorem ipsum dolor sit amet consectetur. Etiam mauris mollis pretium lectus elementum magnis sed non. Dignissim tincidunt aliquet facilisis enim. In egestas eleifend morbi vel feugiat in nam sed. Dui vitae viverra ullamcorper neque mattis massa laoreet tincidunt faucibus.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingThree">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Lorem ipsum
                </button>
              </h2>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
              <div class="card-body">
                Lorem ipsum dolor sit amet consectetur. Etiam mauris mollis pretium lectus elementum magnis sed non. Dignissim tincidunt aliquet facilisis enim. In egestas eleifend morbi vel feugiat in nam sed. Dui vitae viverra ullamcorper neque mattis massa laoreet tincidunt faucibus.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section--3">
      <div class="section--a">
        <h2>Conoce más sobre ANID</h2>
        <div class="sobre-anid">
          <div class="card">
            <h2>ANID</h2>
            <p>Lorem ipsum dolor sit amet consectetur. Vitae amet quis diam vestibulum etiam urna viverra vulputate. Mattis adipiscing erat vitae et cras aliquam. Urna quis ac adipiscing nullam nibh enim. Sapien vitae pretium id ac malesuada cursus morbi enim.</p>
            <button class="button button--sm button--primary" type="button">Conoce más sobre ANID</button>
          </div>
        </div>
      </div>
      <div class="section--b">
        <div class="card--indicador">
          <div class="card--indicador__text">
            <h6>Lorem ipsum</h6>
            <h3>Lorem ipsum</h3>
          </div>
          <span class="icon material-symbols-outlined">info</span>
        </div>
        <div class="card--indicador">
          <div class="card--indicador__text">
            <h6>Lorem ipsum</h6>
            <h3>Lorem ipsum</h3>
          </div>
          <span class="icon material-symbols-outlined">info</span>
        </div>
        <div class="card--indicador">
          <div class="card--indicador__text">
            <h6>Lorem ipsum</h6>
            <h3>Lorem ipsum</h3>
          </div>
          <span class="icon material-symbols-outlined">info</span>
        </div>
        <div class="card--indicador">
          <div class="card--indicador__text">
            <h6>Lorem ipsum</h6>
            <h3>Lorem ipsum</h3>
          </div>
          <span class="icon material-symbols-outlined">info</span>
        </div>
      </div>
    </div>
 </div>